var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import isSameDay from 'date-fns/isSameDay';
import React, { useMemo } from 'react';
import DatePickerBase from './DatePickerBase';
/**
 * Date picker to select a single date
 */
var DatePicker = function (_a) {
    var _b;
    var initialMonth = _a.initialMonth, onChange = _a.onChange, timezone = _a.timezone, value = _a.value, rest = __rest(_a, ["initialMonth", "onChange", "timezone", "value"]);
    var selectedDays = useMemo(function () { return (value ? [value] : undefined); }, [value]);
    var handleChange = function (day) {
        if (onChange) {
            onChange(value && isSameDay(day, value) ? undefined : day);
        }
    };
    return (React.createElement(DatePickerBase, __assign({ initialMonth: (_b = (selectedDays && selectedDays[0])) !== null && _b !== void 0 ? _b : initialMonth, onDayClick: handleChange, selectedDays: selectedDays, timezone: timezone }, rest)));
};
export default DatePicker;
//# sourceMappingURL=DatePicker.js.map